import { render, staticRenderFns } from "./csae.vue?vue&type=template&id=33e4ce14&scoped=true"
import script from "./csae.vue?vue&type=script&lang=js"
export * from "./csae.vue?vue&type=script&lang=js"
import style0 from "./csae.vue?vue&type=style&index=0&id=33e4ce14&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e4ce14",
  null
  
)

export default component.exports